
export class ForecastSalesDto {
  id: number;
  pieMerchantId: number;
  modelId: number;
  actual: number;
  predicted: number;
  actualDate: string;
  createdDate: Date;
  lastModifiedDate: Date;
}